import { useEffect } from "react";

export const APP_TITLE_SUFFIX = "Antecipe";

export function usePageTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} · ${APP_TITLE_SUFFIX}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
